/* eslint-disable max-len */
export default {
  Pineapple: {
    Title: 'Intergalactic Pineapple Studies',
    Description: 'Greetings, weary traveler! You’ve stumbled upon the most groundbreaking, earth-shattering, mind-bending, completely amazing website in the entire multiverse. Here, at the Institute of Intergalactic Pineapple Studies, we’re committed to answering life’s most important questions:',
  },
  ClientPaymentStatus: {
    Title: 'Client Payment Status',
    Description: 'This weeks client payment status',
    WeekOf: `Week of #{weekStart} - #{weekEnd}`,
    ConfirmedHours: `Confirmed Hours: <strong>#{confirmedHours} hrs</strong>`,
    ConfirmedCost: `Cost: <strong>$#{confirmedCost}</strong>`,
    TotalHours: `Total Hours: <strong>#{totalHours} hrs</strong>`,
    ConfirmedTotal: `Cost: <strong>$#{totalCost}</strong>`,
    StatHoliday: `incl. stat holiday 1.5×`,
    Expenses: `Expenses: <strong>$#{expense}</strong>`,
    Progress: {
      IN_PROGRESS: 'In progress',
      COMPLETE: 'Complete',
    },
    MarkAsComplete: `Mark as Complete`,
  },
  CaregiverPaymentStatus: {
    Title: 'Caregiver Payment Status',
    Description: 'This weeks caregiver payment status',
    WeekOf: `Week of #{weekStart} - #{weekEnd}`,
    ConfirmedHours: `Confirmed Hours: <strong>#{confirmedHours} hrs</strong>`,
    TotalHours: `Total Hours: <strong>#{totalHours} hrs</strong>`,
    ConfirmedCost: `Cost: <strong>$#{confirmedCost}</strong>`,
    ConfirmedTotal: `Cost: <strong>$#{totalCost}</strong>`,
    StatHoliday: `incl. stat holiday 1.5×`,
    Expenses: `Reimbursement: <strong>$#{expense}</strong>`,
    TotalPayment: `Total (Confirmed + Expenses): <strong>$#{totalPayment}</strong>`,
    Progress: {
      IN_PROGRESS: 'In progress',
      COMPLETE: 'Complete',
    },
    MarkAsComplete: `Mark as Complete`,
  },
  CaregiverPaymentSyncCsv: {
    Title: 'Caregiver Payment Sync Exports',
    Description: 'Weekly caregiver payment sync csv exports, with download and regenerate',
    Week: 'Week',
    File: 'File',
    Actions: 'Actions',
    Regenerate: 'Regenerate',
    Empty: 'No caregiver payment sync exports yet',
    RegenerateEmpty: 'No caregiver slips found for this week',
    RegenerateError: 'Failed to regenerate this export',
    DownloadError: 'Failed to download this export',
  },
};
